module.exports = __webpack_public_path__ + "../assets/fonts/OpenSans-Regular.629a55a7e793da068dc580d184cc0e31.ttf";